module.exports = __webpack_public_path__ + "static/media/img12.f3f01d30.jpg";